import React, { memo, useCallback, useEffect } from 'react'
import { Fade, Zoom } from 'react-reveal'
import { FormCard } from '../../FormCard'
import SARA from '../../../images/SARA.png'
import QCMLabel from '../QCMLabel'
import questionnaire from '../../../questionnaire.js'
import MultipleChoice from '../MultipleChoice'
import Footer from '../Footer'
import { questionHaveOneMinimumChecked } from '../../../utils'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { selectorQuiz, updateQuiz } from '../../../features/quiz/quizSlice'
import { selectAll } from '../../../features/websites/websitesSlice'
import ToastAction from '../../ToastAction'

function Step0(props) {
  const { section1 } = questionnaire
  const { options, label } = section1.questions.question1
  const dispatch = useDispatch()
  const websites = useSelector(selectAll)
  const quiz = useSelector(selectorQuiz)
  const activeWebsite = useSelector(state => state.websites.activeWebsite)

  useEffect(() => {
    props.firstStep()
  }, [activeWebsite])

  const handleSubmit = useCallback((e) => {
    e.preventDefault()

    if (websites.length <= 0) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Aucun site enregistré !" description="Vérifiez que vous avez enregistré au moins un site pour effectuer le quiz" />)
    if (!activeWebsite) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Aucun site sélectionné par defaut !" description="Sélectionner le site dans le menu au dessus sur lequel vous voudriez effectuer le quiz." />)

    const answers1Checked = questionHaveOneMinimumChecked(e.target, 0, 3, options)

    if (!answers1Checked.length) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question1 requise !" description="Veuillez selectionner au moins un choix pour la question1." />)
    if (!answers1Checked.every((ans, index) => ans === quiz.question1[index])) dispatch(updateQuiz({ question1: answers1Checked }))

    window.scrollTo(0, 0)
    props.nextStep()
  }, [websites, activeWebsite])
  return (
    <form onSubmit={handleSubmit} className="grid grid-cols-3 bg-white shadow rounded-xl px-4 py-8 md:overflow-y-auto m-3">
      <Zoom>
        <img src={SARA} alt="SARA" width={300} height={350} />
      </Zoom>
      <div className="col-span-2 flex flex-col items-center space-y-8 py-10">
        <h1 className="text-lg font-bold">Bienvenue dans votre espace destiné à vos informations d'activité</h1>
        <Fade>
          <p className='text-gray-800 text-sm leading-relaxed font-semibold'>
            Merci de répondre à nos questions afin de nous permettre de comprendre un peu mieux votre profil et ainsi nous proposer un suivi de pilotage plus personnalisé. <br /> <br />
            C'est parti pour 3 min à nos cotés.
          </p>
        </Fade>

        <FormCard title='PROFIL ENTREPRISE'>
          <QCMLabel label={label} />
          <MultipleChoice options={options} defaultValue={quiz.question1} questionNumber='choice_question1' disabled={websites.length <= 0 || !activeWebsite} />
        </FormCard>
        <Footer {...props} />
      </div>
    </form>
  )
}

export default memo(Step0)